import React from 'react'
import { FormattedMessage } from 'react-intl'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import PartnerCarousel from 'components/Common/PartnerBrands/PartnerCarousel'

interface Props {
  className?: string
}

function PartnerBrands({
  className,
}: Props) {
  return (
    <Pane className={className}>
      <LayoutContainer>
        <Group direction="vertical" gap={16}>
          <Group direction="vertical" gap={8}>
            <Heading variant="heading2">
              <FormattedMessage
                id="uOB0Ozj3r7"
                defaultMessage="We partner with the world’s best brands"
                description="Heading for the partner brands section"
              />
            </Heading>
            <BodyText variant="large">
              <FormattedMessage
                id="vWxCLwitbz"
                defaultMessage="Thousands of the best hotels, tours and cruises at your fingertips"
                description="Body text describing the variety of partner brands available"
              />
            </BodyText>
          </Group>
          <PartnerCarousel />
        </Group>
      </LayoutContainer>
    </Pane>
  )
}

export default PartnerBrands
